/** @prettier */
import applicationSagas from './application/sagas';
import betslipSagas from './betslip/sagas';
import casinoControls from './casinoControls/reducer';
import casinoControlsSagas from './casinoControls/sagas';
import customContactForm from './customContactForm/reducer';
import customContactFormSagas from './customContactForm/sagas';
import customerOnboarding from './customerOnboarding/reducer';
import customerOnboardingSagas from './customerOnboarding/sagas';
import eventSagas from './event/sagas';
import eventsSagas from './events/sagas';
import multiplesSagas from './multiples/sagas';
import overlay from './overlay/reducer';
import promoPage from './promoPage/reducer';
import promoPageSagas from './promoPage/sagas';
import relatedEvents from './relatedEvents/reducer';
import relatedEventsSagas from './relatedEvents/sagas';
import rightSidebar from './rightSidebar/reducer';
import rightSidebarSagas from './rightSidebar/sagas';
import userSagas from './user/sagas';
import userSessionSagas from './userSession/sagas';
import vegas from './vegas/reducer';
import vegasSagas from './vegas/sagas';

export const reducers = {
  rightSidebar,
  overlay,
  promoPage,
  relatedEvents,
  vegas,
  customContactForm,
  casinoControls,
  customerOnboarding,
};

export const sagas = [
  userSagas,
  userSessionSagas,
  applicationSagas,
  eventsSagas,
  eventSagas,
  betslipSagas,
  rightSidebarSagas,
  promoPageSagas,
  relatedEventsSagas,
  vegasSagas,
  customContactFormSagas,
  casinoControlsSagas,
  customerOnboardingSagas,
  multiplesSagas,
];
